import React, { useContext, useEffect, useMemo } from 'react';
import { get, map, set } from 'lodash';

import answerLanguagesResource from 'src/actions/answers/answerLanguagesResource';
import { DropdownMediumWidth } from 'src/presentation/components/forms/Dropdown';
import FormContext from 'src/presentation/contexts/FormContext';
import { default as Languages } from '@ad-scripts/domain/models/languages/answer_languages';
import { STATUS_SUCCEEDED } from 'src/presentation/hooks/useResource';
import { useDocumentResourceAll } from 'src/presentation/hooks/useDocumentResource';

const LanguagesDropdown = ({ attr }) => {
  const { updateState, workingState } = useContext(FormContext);

  const { value: languages, loadingState: languagesLoadingState } = useDocumentResourceAll(answerLanguagesResource);

  const selectedLanguage = get(workingState, attr);

  const languagesOptions = useMemo(
    () => map(languages, language => ({ label: Languages[language], value: language })),
    [languages]
  );

  useEffect(() => {
    if (languagesOptions.length && !selectedLanguage) {
      updateState(set({}, attr, languagesOptions[0].value));
    }
  }, [attr, selectedLanguage, languagesOptions, updateState]);

  return (
    <DropdownMediumWidth
      attr={attr}
      className={attr}
      searchable
      data-aid={attr}
      disabled={languagesLoadingState !== STATUS_SUCCEEDED}
      label="Language"
      options={languagesOptions}
      placeholder="Select a Language"
    />
  );
};

export default LanguagesDropdown;
